import { isCatalogOnlyBlockedRoute } from '~~/shared/utils/catalogOnly'

/**
 * Tryb katalogowy: trasy zakupowe nie istnieją.
 *
 * 404, a nie przekierowanie na stronę główną — przekierowanie sugeruje, że
 * strona jest gdzie indziej, a tu chodzi o to, że w tym sklepie jej nie ma.
 * To także kryterium akceptacji zadania: `/cart`, `/checkout` i `/account`
 * mają odpowiedzieć 404, nie 302 i nie pustą stroną.
 *
 * Globalne middleware zamiast `definePageMeta` na każdej stronie: nowa
 * podstrona konta czy checkoutu ma być zamknięta od pierwszego commitu, bez
 * pamiętania o dopisaniu jej gdziekolwiek. Ta sama zasada, co po stronie API,
 * gdzie o blokadzie decyduje położenie kontrolera, a nie lista adresów.
 *
 * Przy wyłączonej fladze middleware kończy się na jednym porównaniu — lavmag i
 * youlook nie odczuwają go w żaden sposób.
 */
export default defineNuxtRouteMiddleware((to) => {
  const config = useRuntimeConfig()

  if (config.public.catalogOnly !== true) return

  if (!isCatalogOnlyBlockedRoute(to.path)) return

  return abortNavigation(
    createError({ statusCode: 404, statusMessage: 'Strona nie istnieje', fatal: true }),
  )
})
